export default __webpack_public_path__ + "static/media/mama.2b597baa.png";